import type { CameraRoute } from '@datum-sdk/scene-format';

/**
 * The 2030s preloader flights, as SDK scene data: the tour, then a flyover of
 * two views that glides in past the complex and settles on the rest pose — its
 * last view.
 *
 * Converted once from the legacy `kaabaFutureSceneConfig.camera` by
 * `convertLegacyPreloader.ts` (which says what in here is load-bearing); the
 * routes are the source since. Tune them in the SDK editor (`?flight` → Routes →
 * Copy Routes) — the same workflow as `kaabaRoutes.ts` — and
 * `sceneRoutes.test.ts` holds them to what the preloader and the scene need.
 *
 * The tour rings 6.57 out against `orbitMaxDistance` 4.6: a route applies no
 * orbit limits, and the flyover lands back inside them.
 */
export const KAABA_FUTURE_CAMERA_ROUTES: CameraRoute[] = [
  {
    id: 'preview-enter',
    waypoints: [
      {
        target: [-0.34, 2.26, -5.95],
        lookAt: [-0.02, -0.54, -0.01],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
      {
        orbit: {
          radius: 6.57464828,
          azimuth: -1.441356784,
          polar: 1.130863935,
        },
        target: [-0.02, -0.54, -0.01],
        lookAt: 'target',
        duration: 500,
        easing: [0.333333333, 0, 0.666666667, 0.333333333],
      },
    ],
  },
  {
    id: 'preview-turntable',
    loop: true,
    waypoints: [
      {
        orbit: {
          radius: 6.57464828,
          azimuth: 0.129439543,
          polar: 1.130863935,
        },
        target: [-0.02, -0.54, -0.01],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.57464828,
          azimuth: 1.70023587,
          polar: 1.130863935,
        },
        target: [-0.02, -0.54, -0.01],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.57464828,
          azimuth: 3.271032196,
          polar: 1.130863935,
        },
        target: [-0.02, -0.54, -0.01],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
      {
        orbit: {
          radius: 6.57464828,
          azimuth: 4.841828523,
          polar: 1.130863935,
        },
        target: [-0.02, -0.54, -0.01],
        lookAt: 'target',
        duration: 2142.857142857,
        easing: 'linear',
      },
    ],
  },
  {
    id: 'preview-exit',
    waypoints: [
      {
        target: [0.35, 1.06, 2.89],
        lookAt: [-0.02, -0.54, -0.01],
        duration: 1000,
        easing: [0.65, 0, 0.35, 1],
      },
    ],
  },
  {
    id: 'preloader-flyover',
    waypoints: [
      {
        duration: 1200,
      },
      {
        kind: 'view',
        position: [-1.615, 0.26, 0.194],
        lookAt: [-0.02, -0.54, -0.01],
        duration: 4500,
        easing: [0.333333333, 0, 0.666666667, 0.599948711],
      },
      {
        kind: 'view',
        position: [-0.39, 1.06, -2.91],
        lookAt: [-0.02, -0.54, -0.01],
        duration: 3000,
        easing: [0.333333333, 0.266635892, 0.666666667, 1],
      },
    ],
  },
];
